import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { convertProductsIds } from '../../utils/utils';
import { Product } from '../../models/Product';
import { ProductStocksResponse } from '../../models/ProductStock';

const PRODUCT_QUANTITY_URL = '/api/v1/quantities';

const useProductStocksSWR = (products: Product[]) => {
    const fetchQuantity = (query, products) => {
        return httpApi
            .post<ProductStocksResponse>(query, products)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [PRODUCT_QUANTITY_URL, convertProductsIds(products)],
        ([url, products]) => fetchQuantity(url, products),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    const getDefaultStock = (locations, variantId) => {
        return locations.find(
            (elem) => elem.default && elem.variantId == variantId
        );
    };

    return {
        stocks: data ? data.stocks : null,
        isLoading: isLoading,
        isError: error,
        mutate,
        getDefaultStock,
    };
};

export default useProductStocksSWR;
